import ky from "ky";
import moize from "moize";
import mergeAdvanced from "object-merge-advanced";

const networkError = e => ({
  error: e,
  success: false,
  message: "A network error has occurred, please try again later."
});

export function getToken() {
  console.log("gettoken", localStorage.getItem("token"), sessionStorage.getItem("token"));
  const localToken = localStorage.getItem("token");
  if (localToken) return localToken;
  const sessionToken = sessionStorage.getItem("token");
  return sessionToken;
}

// common api options sent with every request
const api = {
  headers: {
    authorization: getToken(),
    "Content-Type": "application/json"
  }
};

if (!api.headers.authorization) delete api.headers.authorization;

export function setAccountId(accountId) {
  api.headers["X-Account-Id"] = accountId;
  window.appInfo.accountId = accountId;
}

export function setPrefixUrl(prefixUrl) {
  api.prefixUrl = prefixUrl;
}

export async function getDataNoCache(href, params) {
  try {
    const mergedParams = params ? mergeAdvanced(api, params) : api;
    const response = await ky(href, mergedParams).json();
    return response;
  } catch (e) {
    //...exception reporting?
    return networkError(e);
  }
}

export const getData = moize(getDataNoCache, {
  isPromise: true,
  transformArgs: ([url]) => [url]
});

export function clearApiCache() {
  getData.clear();
}

export function setToken(token, remember) {
  console.log("setToken");
  if (!token) {
    delete api.headers.authorization;
    if (remember) localStorage.removeItem("token");
    else sessionStorage.removeItem("token");
  } else {
    api.headers.authorization = token;
    if (remember) localStorage.setItem("token", api.headers.authorization);
    else sessionStorage.setItem("token", api.headers.authorization);
  }
  clearApiCache();
}

export function removeToken() {
  delete api.headers.authorization;
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  clearApiCache();
}

const transform = function(obj, fun) {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === "string" || typeof obj === "number") return obj;
  if (Array.isArray(obj)) return fun(obj);
  Object.keys(obj).forEach(function(k) {
    obj[k] = transform(obj[k], fun);
  });
  return obj;
};

export const transformErrors = errors =>
  transform(errors, val => (typeof val[0] === "string" ? val.join(", ") : val));

export async function putData(href, item, params) {
  // clear cache entry for this href
  getData.remove([href]);

  try {
    const httpResponse = await ky.put(href, {
      ...params,
      ...api,
      json: item
    });
    const response = await httpResponse.json();
    return { ...response, message: transformErrors(response.message) };
  } catch (e) {
    //...exception reporting?
    return networkError(e);
  }
}

export async function deleteData(href, item, params) {
  try {
    // clear cache entry for this href
    getData.remove([href]);

    const response = await ky
      .delete(href, {
        ...params,
        ...api,
        json: item
      })
      .json();
    return { ...response, message: transformErrors(response.message) };
  } catch (e) {
    return networkError(e);
  }
}

export async function postData(href, item, params) {
  // clear cache entry for this href
  getData.remove([href]);

  try {
    const mergedParams = params ? mergeAdvanced(api, params) : api;
    const httpResponse = await ky.post(href, {
      ...mergedParams,
      json: item
    });
    const response = await httpResponse.json();
    return { ...response, message: transformErrors(response.message) };
  } catch (e) {
    //...exception reporting?
    return networkError(e);
  }
}

export async function patchData(href, body, params) {
  // clear cache entry for this href
  getData.remove([href]);

  try {
    const mergedParams = params ? mergeAdvanced(api, params) : api;
    const httpResponse = await ky.patch(href, {
      ...mergedParams,
      json: body
    });
    const response = await httpResponse.json();
    return { ...response, message: transformErrors(response.message) };
  } catch (e) {
    return networkError(e);
  }
}
